"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WELCOME_TIMING = void 0;
exports.WelcomeTransition = WelcomeTransition;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ The welcome transition — from a created workspace into its dashboard.     │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * A full-screen overlay that plays once: the screen fades to white, the Forecastify mark assembles
 * stroke by stroke the moment it is white, and the white lifts to show the dashboard beneath.
 *
 * ⚠️ **No check mark** — product owner, 13 Oct 2026: *"no checkmark needed, when it fades to
 * white, instantly show the forecastify logo animation and then fade to the dashboard"*. The
 * film's green disc, tick and rays are gone, and the mark moved up into the time they took. The motion is `welcome-transition.css`; this only mounts it and says when it is over.
 *
 * ⚠️ **Decorative, so `aria-hidden` and no text.** It says nothing a screen reader needs — the
 * dashboard it uncovers is the news — and it takes no input (`pointer-events: none`).
 *
 * ⚠️ **The caller decides whether it plays** (reduced motion, above all). Mounted, it always runs
 * its full length and then calls `onDone` exactly once.
 */
/** The two moments a caller waits on, in ms from mount — `welcome-transition.css`'s timeline. */
exports.WELCOME_TIMING = {
    /** The screen is fully white: what is under it can change unseen. */
    whiteMs: 650,
    /** The white has lifted: unmount. */
    totalMs: 2600,
};
function WelcomeTransition({ onDone }) {
    /* ⚠️ A ref, so a parent re-rendering with a new arrow does not restart the timer. */
    const done = (0, react_1.useRef)(onDone);
    done.current = onDone;
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(() => {
            done.current();
        }, exports.WELCOME_TIMING.totalMs);
        return () => {
            clearTimeout(timer);
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "welcome-transition", "aria-hidden": "true", "data-testid": "welcome-transition", children: [(0, jsx_runtime_1.jsx)("div", { className: "wt-veil" }), (0, jsx_runtime_1.jsxs)("svg", { className: "wt-mark", viewBox: "0 0 116 193", children: [(0, jsx_runtime_1.jsx)("path", { className: "wt-stroke wt-stroke-top", d: "M20.13 115.76C14.98 115.76 9.82 113.8 5.9 109.86C-1.97 102 -1.97 89.25 5.9 81.38L81.4 5.9C89.26 -1.97 102.01 -1.97 109.87 5.9C117.74 13.76 117.74 26.51 109.87 34.37L34.37 109.87C30.45 113.8 25.29 115.77 20.14 115.77Z" }), (0, jsx_runtime_1.jsx)("path", { className: "wt-stroke wt-stroke-mid", d: "M57.88 153.51C52.73 153.51 47.57 151.55 43.65 147.61C35.78 139.75 35.78 127 43.65 119.14L81.4 81.39C89.26 73.52 102.01 73.52 109.87 81.39C117.74 89.25 117.74 102 109.87 109.86L72.12 147.61C68.2 151.54 63.04 153.51 57.89 153.51Z" }), (0, jsx_runtime_1.jsx)("circle", { className: "wt-stroke wt-stroke-dot", cx: "95.63", cy: "172.39", r: "20.13" })] })] }));
}
//# sourceMappingURL=welcome-transition.js.map